import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import "./Header.scss";

function Aside() {
  const [showMenu, setShowMenu] = useState(!isMobile);

  const toggleMenu: any = () => {
    console.log("STATUS::1", showMenu);
    console.log("STATUS::2", !showMenu);
    setShowMenu(!showMenu);
  };

  const toggleNav = (item: any) => {
    item.classList.toggle('show');
    const subMenu = item.querySelector('.menu-sub');
    if (subMenu) {
      subMenu.classList.toggle('d-none');
    }
  }

  return (
    <>
      {/*begin::Sidebar*/}
      <div
        id="kt_app_sidebar"
        className="app-sidebar flex-column"
        data-kt-drawer="true"
        data-kt-drawer-name="app-sidebar"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="225px"
        data-kt-drawer-direction="start"
        data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
      >
        {/*begin::Logo*/}
        <div className="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
          {/*begin::Logo image*/}
          <a href="/">
            <img
              alt="Logo"
              src="/assets/img/logo-dark.svg"
              className="h-25px app-sidebar-logo-default"
            />
            <img
              alt="Logo"
              src="/assets/img/logo-dark.svg"
              className="h-20px app-sidebar-logo-minimize"
            />
          </a>

          <div
            id="kt_app_sidebar_toggle"
            className="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate d-none"
            data-kt-toggle="true"
            data-kt-toggle-state="active"
            data-kt-toggle-target="body"
            data-kt-toggle-name="app-sidebar-minimize"
          >
            <i className="ki-duotone ki-black-left-line fs-3 rotate-180">
              <span className="path1" />
              <span className="path2" />
            </i>
          </div>
          {/*end::Sidebar toggle*/}
        </div>
        {/*end::Logo*/}
        {/*begin::sidebar menu*/}
        <div className="app-sidebar-menu overflow-hidden flex-column-fluid">
          {/*begin::Menu wrapper*/}
          <div id="kt_app_sidebar_menu_wrapper" className="app-sidebar-wrapper">
            {/*begin::Scroll wrapper*/}
            <div
              id="#kt_aside_menu"
              data-kt-menu="true"
              className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
            >
              <div className="menu-item">
                <div className="menu-content pb-2">
                  <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                    Dashboard
                  </span>
                </div>
              </div>
              <div className="menu-item">
                <a className="menu-link active" href="/category">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x={2}
                          y={2}
                          width={9}
                          height={9}
                          rx={2}
                          fill="black"
                        />
                        <rect
                          opacity="0.3"
                          x={13}
                          y={2}
                          width={9}
                          height={9}
                          rx={2}
                          fill="black"
                        />
                        <rect
                          opacity="0.3"
                          x={13}
                          y={13}
                          width={9}
                          height={9}
                          rx={2}
                          fill="black"
                        />
                        <rect
                          opacity="0.3"
                          x={2}
                          y={13}
                          width={9}
                          height={9}
                          rx={2}
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Categories</span>
                </a>
              </div>
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion hover "
                onClick={(e) => toggleNav(e.currentTarget)}
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <i className="ki-duotone ki-address-book fs-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={25}
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
                          fill="black"
                        />
                        <path
                          d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
                          fill="black"
                        />
                      </svg>
                    </i>
                  </span>
                  <span className="menu-title">Category Groups</span>
                  <span className="menu-arrow" />
                </span>
                <div
                  className="menu-sub menu-sub-accordion d-none"
                  style={{}}
                  kt-hidden-height={117}
                >
                  <div className="menu-item">
                    <a href="/category-group/top" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Store Front Top</span>
                    </a>
                  </div>
                  <div className="menu-item">
                    <a href="/category-group/left" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Store Front Side</span>
                    </a>
                  </div>
                  <div className="menu-item">
                    <a href="/category-group/rfq" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">RFQ Form</span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion hover"
                data-menu-item-toggle="accordion"
                onClick={(e) => toggleNav(e.currentTarget)}
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <i className="ki-duotone ki-address-book fs-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={25}
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
                          fill="black"
                        />
                        <path
                          d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
                          fill="black"
                        />
                      </svg>
                    </i>
                  </span>
                  <span className="menu-title">Rewards Zone</span>
                  <span className="menu-arrow" />
                </span>
                <div
                  className="menu-sub menu-sub-accordion d-none"
                  style={{}}
                  kt-hidden-height={117}
                >
                  <div className="menu-item">
                    <a href="/rewards/levels" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Reward Levels</span>
                    </a>
                  </div>
                  <div className="menu-item">
                    <a href="/rewards/event-types" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Reward Event Types</span>
                    </a>
                  </div>
                  <div className="menu-item">
                    <a href="/rewards/items" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Rewards Items</span>
                    </a>
                  </div>
                  <div className="menu-item">
                    <a href="/rewards/groups" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Rewards Groups</span>
                    </a>
                  </div>
                  <div className="menu-item">
                    <a href="/rewards/tenant-groups" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Tenant Groups</span>
                    </a>
                  </div>
                </div>
              </div>


              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion hover "
                onClick={(e) => toggleNav(e.currentTarget)}
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <i className="ki-duotone ki-address-book fs-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={25}
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
                          fill="black"
                        />
                        <path
                          d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
                          fill="black"
                        />
                      </svg>
                    </i>
                  </span>
                  <span className="menu-title">Products</span>
                  <span className="menu-arrow" />
                </span>
                <div
                  className="menu-sub menu-sub-accordion d-none"
                  style={{}}
                  kt-hidden-height={117}
                >
                  <div className="menu-item">
                    <a href="/product-attachments" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Product Attachments</span>
                    </a>
                  </div>
                </div>
              </div>

              <div
                data-kt-menu-trigger="click"
                className="menu-item menu-accordion hover "
                onClick={(e) => toggleNav(e.currentTarget)}
              >
                <span className="menu-link">
                  <span className="menu-icon">
                    <i className="ki-duotone ki-address-book fs-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={25}
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
                          fill="black"
                        />
                        <path
                          d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
                          fill="black"
                        />
                      </svg>
                    </i>
                  </span>
                  <span className="menu-title">Analytics</span>
                  <span className="menu-arrow" />
                </span>
                <div
                  className="menu-sub menu-sub-accordion d-none"
                  style={{}}
                  kt-hidden-height={117}
                >
                  <div className="menu-item">
                    <a href="/analytics/transactions" className="menu-link">
                      <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                      </span>
                      <span className="menu-title">Transaction History</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="menu-item">
                <a className="menu-link" href="/tenant-invites">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M20 21H3C2.4 21 2 20.6 2 20V10C2 9.4 2.4 9 3 9H20C20.6 9 21 9.4 21 10V20C21 20.6 20.6 21 20 21Z"
                          fill="black"
                        />
                        <path
                          d="M20 7H3C2.4 7 2 6.6 2 6V3C2 2.4 2.4 2 3 2H20C20.6 2 21 2.4 21 3V6C21 6.6 20.6 7 20 7Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Tenant Invites</span>
                </a>
              </div>
              <div className="menu-item">
                <a className="menu-link" href="/sellers">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={25}
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
                          fill="black"
                        />
                        <path
                          d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Seller Profiles</span>
                </a>
              </div>
              <div className="menu-item">
                <a className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                          fill="black"
                        />
                        <path
                          d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Brands</span>
                </a>
              </div>
              <div className="menu-item">
                <a className="menu-link">
                  <span className="menu-icon">
                    <span className="svg-icon svg-icon-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M20 21H3C2.4 21 2 20.6 2 20V10C2 9.4 2.4 9 3 9H20C20.6 9 21 9.4 21 10V20C21 20.6 20.6 21 20 21Z"
                          fill="black"
                        />
                        <path
                          d="M20 7H3C2.4 7 2 6.6 2 6V3C2 2.4 2.4 2 3 2H20C20.6 2 21 2.4 21 3V6C21 6.6 20.6 7 20 7Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                  </span>
                  <span className="menu-title">Admin Users</span>
                </a>
              </div>

            </div>

            {/*end::Scroll wrapper*/}
          </div>
          {/*end::Menu wrapper*/}
        </div>
        {/*end::sidebar menu*/}
        {/*begin::Footer*/}
        <div
          className="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6"
          id="kt_app_sidebar_footer"
        >
          <a
            href="https://preview.keenthemes.com/html/metronic/docs"
            className="btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-dismiss-="click"
            data-bs-original-title="200+ in-house components and 3rd-party plugins"
            data-kt-initialized={1}
          >
            <span className="btn-label">Docs &amp; Components</span>
            <i className="ki-duotone ki-document btn-icon fs-2 m-0">
              <span className="path1" />
              <span className="path2" />
            </i>{" "}
          </a>
        </div>
        {/*end::Footer*/}
      </div>
      {/*end::Sidebar*/}
    </>
  );
}

export default Aside;
